import { Grid } from '@chakra-ui/react'
import { useEffect, useRef, useState } from 'react'

import { Apps } from '@/dtos'
import { useApp } from '@/hooks/useApp'
import { useTranslationsContext } from 'BrokerTsLib/src/context/TranslationsContext'
import { useNavigate } from 'react-router'
import { useInsuranceParams } from '../../context/InsuranceParamsProvider'
import { useStepsContext } from '../../context/StepsContext'
import { throttle } from '../../utils/throttle'
import { Step } from './Step'
import { StepsContainer } from './StepsContainer'


export const Steps = () => {
  const { translate } = useTranslationsContext()
  const { app } = useApp()
  const isPublicPoleas = app == Apps.publicPoleas
  const navigate = useNavigate()
  const { insuranceParamsId, insuranceParams } = useInsuranceParams()
  const { steps, currentStepId } = useStepsContext()
  const lastStep = insuranceParams?.generalParams?.lastWizardStep ?? 1

  const ref = useRef<HTMLDivElement>(null)
  const [isFixed, setIsFixed] = useState(false)
  const stickyOffset = 8
  const threshold = 76 + 56 - stickyOffset // header height + steps height - offset

  useEffect(() => {
    const handleScroll = () => {
      const windowScrollTop = window.pageYOffset

      if (windowScrollTop > threshold) {
        setIsFixed(true)
      } else {
        setIsFixed(false)
      }
    }

    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', throttle(handleScroll))
    }
  }, [threshold])

  // znemozneni preskakovani kroku
  useEffect(() => {
    if (isPublicPoleas
      && steps
      && currentStepId
      && insuranceParams?.generalParams?.lastWizardStep
      && currentStepId > insuranceParams.generalParams.lastWizardStep) {
      navigate(steps.find(s => s.id == insuranceParams!.generalParams!.lastWizardStep)!.path)
    }
  }, [isPublicPoleas, steps])

  return (
    <Grid sx={{ w: '100%', h: '56px' }}>
      <StepsContainer
        ref={ref}
        id="steps-container"
        sx={{
          position: isFixed ? 'fixed' : 'relative',
          top: isFixed ? '0' : 'auto',
          left: 0,
          right: 0,
          transform: isFixed
            ? `translateY(calc(-100% + ${stickyOffset}px))`
            : 'translateY(0)',
          zIndex: 'sticky',
        }}
      >
        {steps &&
          steps.length > 0 &&
          steps.map((step) => (
            <Step
              key={step.id}
              id={step.id}
              title={translate(step.titleKey, step.title)}
              isDisabled={step.id > lastStep}
              path={insuranceParamsId ? `${step.path}/${insuranceParamsId}` : step.path}
              isCurrent={step.id === currentStepId}
              isPassed={!!currentStepId && step.id < currentStepId}
              isLast={step.id === steps.length}
              isContentHidden={isFixed}
            >
              {step.id}
            </Step>
          ))}
      </StepsContainer>
    </Grid>
  )
}
